import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-group-child" }
const _hoisted_2 = { for: "name" }
const _hoisted_3 = { class: "t-input-group" }
const _hoisted_4 = ["placeholder", "value"]
const _hoisted_5 = {
  key: 0,
  class: "error-text",
  "data-qe-id": "user-name-error"
}

import { validateNameAsync } from '@/lib/userNameRequirements'
import { beforeInputIgnoreSpace, removeSpace } from '@/lib/utils'
import { UserName } from '@/model/UserName'
import { Ref, ref, watch } from 'vue'

interface Props {
  validate?: boolean
  modelValue: UserName
  validUserName?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UserNameInput',
  props: {
    validate: { type: Boolean },
    modelValue: {},
    validUserName: { default: '' }
  },
  emits: ['update:modelValue', 'reset'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const name: Ref<UserName> = ref({
  value: props.modelValue.value,
  valid: false,
  errorCode: undefined,
  length: false,
  namePattern: false,
  isAvailable: false,
})

// used to activate the error text below the input field ( different behavior for (name, mail) and password)
const enableNameValidation = ref(false)

watch(
  () => props.modelValue,
  (to: UserName) => {
    name.value = to
  },
  { deep: true },
)

watch(
  () => props.validate,
  (to: boolean) => {
    enableNameValidation.value = to
  },
)

const validateName = (v: string) => {
  // validation logic:
  // start validation after first leave
  // continue validation as long something is wrong
  // clear error state if string is empty
  const s = removeSpace(v)
  if (s.length > 0 && props.validUserName === s) {
    name.value.value = s
    name.value.errorCode = undefined
    name.value.isAvailable = true
    name.value.length = true
    name.value.namePattern = true
    name.value.valid = true
    emit('update:modelValue', name.value)
    return
  }
  validateNameAsync(s, enableNameValidation.value).then((n) => {
    name.value = n
    if (name.value.valid) {
      // Removed s.length === 0 from here. Issues?
      enableNameValidation.value = false
      emit('reset')
    }
    emit('update:modelValue', name.value)
  })
}

const onNameBlur = () => {
  if (name.value.value.length > 0) {
    enableNameValidation.value = true

    if (props.validUserName === name.value.value) {
      return
    }

    validateNameAsync(name.value.value, true).then((n) => {
      name.value = n
      if (name.value.valid && name.value.isAvailable) {
        enableNameValidation.value = false
        emit('reset')
      }
    })
  }
}

const beforeInput = (event: InputEvent) => {
  beforeInputIgnoreSpace(event)
}

const onInput = (event: Event) => {
  const value = (event.target as HTMLInputElement).value
  validateName(value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('form.label.username')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        autocomplete: "username",
        "data-qe-id": "user-name",
        id: "name",
        name: "commonName",
        placeholder: _ctx.$t('form.placeholder.username'),
        onBeforeinput: beforeInput,
        type: "text",
        value: name.value.value,
        class: _normalizeClass(enableNameValidation.value && name.value.errorCode ? 'error' : ''),
        onBlur: onNameBlur,
        onInput: onInput,
        maxlength: "20"
      }, null, 42, _hoisted_4)
    ]),
    (enableNameValidation.value && name.value.errorCode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t(`form.errors.${name.value.errorCode}`)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})